/**
 * Labstep
 *
 * @module prosemirror/marks
 * @desc ProseMirror Marks Definitions
 */

import { MarkBackgroundColor } from 'labstep-web/prosemirror/marks/background-color';
import { MarkCode } from 'labstep-web/prosemirror/marks/code';
import { MarkColor } from 'labstep-web/prosemirror/marks/color';
import { MarkItalic } from 'labstep-web/prosemirror/marks/italic';
import { MarkLink } from 'labstep-web/prosemirror/marks/link';
import { MarkStrike } from 'labstep-web/prosemirror/marks/strike';
import { MarkStrong } from 'labstep-web/prosemirror/marks/strong';
import { MarkSub } from 'labstep-web/prosemirror/marks/sub';
import { MarkSup } from 'labstep-web/prosemirror/marks/sup';
import { MarkUnderline } from 'labstep-web/prosemirror/marks/underline';
import { keymap } from 'prosemirror-keymap';
import type { Plugin } from 'prosemirror-state';
import type { LabstepMark } from './types';
export const marks: LabstepMark[] = [
  MarkStrong,
  MarkItalic,
  MarkUnderline,
  MarkSub,
  MarkSup,
  MarkStrike,
  MarkBackgroundColor,
  MarkCode,
  MarkColor,
  MarkLink,
];

export const spec = marks.reduce(
  (result, mark) => ({ ...result, [mark.key]: mark.spec }),
  {},
);

const marksKeymap = marks.reduce(
  (result, mark) =>
    mark.keymap ? [...result, keymap(mark.keymap)] : result,
  [] as Plugin[],
);

export const plugins = marksKeymap;
